import ouiBase from '@goldwasserexchange/oui';

export type OpenVariantNames = 'opened' | 'closed';

export function useOpenVariants(): OpenVariantNames {
  const isOpen = ouiBase.List.useSelectIsOpen();
  return isOpen ? 'opened' : 'closed';
}
